(() => {
  const canonical = ['XXS','XS','S','M','L','XL','2XL','3XL','4XL','5XL','6XL'];
  const rank = new Map(canonical.map((value, index) => [value, index]));
  const aliases = {
    'EXTRAEXTRASMALL':'XXS','EXTRASMALL':'XS','SMALL':'S','MEDIUM':'M','LARGE':'L',
    'EXTRALARGE':'XL','XLARGE':'XL','XXL':'2XL','2X':'2XL','2XLARGE':'2XL',
    'XXXL':'3XL','3X':'3XL','3XLARGE':'3XL','XXXXL':'4XL','4X':'4XL','4XLARGE':'4XL',
    '5X':'5XL','5XLARGE':'5XL','6X':'6XL','6XLARGE':'6XL'
  };

  const normalize = (value = '') => {
    const cleaned = String(value).toUpperCase().replace(/[^A-Z0-9]/g, '');
    return aliases[cleaned] || cleaned;
  };

  const score = (value, fallback) => {
    const normalized = normalize(value);
    return rank.has(normalized) ? rank.get(normalized) : 1000 + fallback;
  };

  function sortButtonPicker(fieldset) {
    const labels = [...fieldset.querySelectorAll(':scope > .variant-option__button-label')];
    if (labels.length < 2) return;
    const firstInput = labels[0].querySelector('input[data-option-name]');
    if (!firstInput || (firstInput.dataset.optionName || '').trim().toLowerCase() !== 'size') return;

    const decorated = labels.map((node, index) => ({
      node,
      index,
      value: node.querySelector('input')?.value || node.textContent.trim()
    }));
    const sorted = [...decorated].sort((a, b) => score(a.value, a.index) - score(b.value, b.index));
    if (decorated.every((item, index) => item.node === sorted[index].node)) return;

    const anchor = [...fieldset.children].find((child) => child.tagName === 'STYLE') || null;
    sorted.forEach(({ node }) => fieldset.insertBefore(node, anchor));
  }

  function sortSelect(select) {
    const options = [...select.options];
    if (options.length < 2) return;
    const isSize = /^options\[size\]$/i.test(select.name || '') || options.some((option) => (option.dataset.optionName || '').trim().toLowerCase() === 'size');
    if (!isSize) return;

    const selectedValue = select.value;
    const decorated = options.map((node, index) => ({ node, index, value: node.value || node.textContent.trim() }));
    const sorted = [...decorated].sort((a, b) => score(a.value, a.index) - score(b.value, b.index));
    if (decorated.every((item, index) => item.node === sorted[index].node)) return;
    sorted.forEach(({ node }) => select.appendChild(node));
    select.value = selectedValue;
  }

  function sortSizePickers(root = document) {
    root.querySelectorAll?.('fieldset.variant-option').forEach(sortButtonPicker);
    root.querySelectorAll?.('select.variant-option__select').forEach(sortSelect);
  }

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      sortSizePickers(document);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();

  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver((mutations) => {
    const relevant = mutations.some((mutation) => [...mutation.addedNodes].some((node) => node.nodeType === 1 && (node.matches?.('variant-picker, fieldset.variant-option, select.variant-option__select, .variant-option__button-label') || node.querySelector?.('variant-picker, fieldset.variant-option, select.variant-option__select'))));
    if (relevant) schedule();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
